export default "__VITE_ASSET__08de73a1__"